var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6357 5.28884C17.3174 5.28884 17.0121 5.41298 16.787 5.63395L5.97543 16.2481L5.40965 18.4699L7.67276 17.9144L18.4844 7.30029C18.5958 7.19087 18.6842 7.06098 18.7445 6.91803C18.8048 6.77507 18.8359 6.62185 18.8359 6.46712C18.8359 6.31239 18.8048 6.15917 18.7445 6.01621C18.6842 5.87326 18.5958 5.74336 18.4844 5.63395C18.3729 5.52454 18.2406 5.43775 18.095 5.37853C17.9494 5.31932 17.7933 5.28884 17.6357 5.28884ZM15.8587 4.7226C16.33 4.25993 16.9692 4 17.6357 4C17.9657 4 18.2925 4.06381 18.5974 4.1878C18.9023 4.31178 19.1793 4.49351 19.4127 4.7226C19.646 4.9517 19.8311 5.22367 19.9574 5.52299C20.0837 5.82232 20.1487 6.14313 20.1487 6.46712C20.1487 6.79111 20.0837 7.11192 19.9574 7.41124C19.8311 7.71057 19.646 7.98254 19.4127 8.21163L8.4725 18.952C8.38838 19.0346 8.28297 19.0932 8.16755 19.1215L4.6667 19.9807C4.44301 20.0356 4.20639 19.9713 4.04335 19.8112C3.88031 19.6511 3.81476 19.4188 3.87069 19.1992L4.7459 15.7623C4.77475 15.649 4.83443 15.5455 4.91856 15.463L15.8587 4.7226Z",
    fill: "#4F6FFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.04eb64a5dc923ad3dd67e7014fd76406.svg";
export { ForwardRef as ReactComponent };